exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___QN5fX{text-align:center}.style__headline___uJrb9{position:relative;display:inline-block;text-transform:uppercase;font-family:PlayfairDisplay-Regular;font-size:40px;letter-spacing:2.4px;color:#333;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5;padding:20px 0;font-weight:300}.style__headline___uJrb9.style__lg___29JoF{font-size:90px;margin:40px 0}.style__title___3Vz8m{position:absolute;top:0;left:50%;font-family:Poppins-Light;font-size:11px;text-transform:uppercase;letter-spacing:2.6px;color:#333}.style__lg___29JoF>.style__title___3Vz8m{font-size:14px}.style__title___3Vz8m span{position:relative;top:-9px;left:-50%;white-space:nowrap;padding:0 20px;background:#f8f8f8}.style__headline___uJrb9:after{content:\" \";display:block;position:absolute;bottom:-5px;left:calc(50% - 5px);width:10px;height:10px;background:#e7c0b9;transform:rotate(45deg)}.style__subtitle___3BjYj{margin-top:-5px;font-family:Poppins-Light;font-size:18px;font-weight:300;line-height:1.7;letter-spacing:.5px;text-align:center;color:#333}", ""]);

// exports
exports.locals = {
	"container": "style__container___QN5fX",
	"headline": "style__headline___uJrb9",
	"lg": "style__lg___29JoF",
	"title": "style__title___3Vz8m",
	"subtitle": "style__subtitle___3BjYj"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/page-title/style.css
// module id = 704
// module chunks = 0